import { Box, Card, IconButton, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import styles from '../../settingsTabs/venderSettingTabs.module.scss'
import { BusinessProfileDetailsModal } from './BusinessProfileDetailsModal'

export const BusinessInfoCard = ({
	formData,
	cardStyle,
	editable = false,
	setFormData = () => {},
}) => {
	const [editOpen, setEditOpen] = useState(false)
	const types =
		[formData?.businessTypes?.join(', '), formData?.customBusinessType]
			.filter(Boolean)
			.join(', ') || ''

	const businessInfo = [
		['Name', formData?.businessName],
		['Type', types],
		['Location', formData?.businessAddress],
		['Capacity', formData?.maxCapacity],
	]

	const vendorType = useSelector((state) => state.auth.user.type)

	return (
		<Card
			sx={cardStyle}
			variant="outlined"
			className={styles.vendorCardBusinessInfo}
		>
			<div className={styles.infoHeader}>
				<Typography
					variant="h5"
					gutterBottom
					sx={{ fontWeight: 'bold' }}
				>
					Business Info
				</Typography>
				{editable && (
					<IconButton
						component="label"
						className={styles.editIcon}
						disableRipple
						onClick={() => setEditOpen(true)}
						data-cy="edit-business-info"
					>
						<img
							src="/images/edit-icon.svg"
							alt="Edit business details"
						/>
					</IconButton>
				)}
			</div>

			{businessInfo.map((label, i) => {
				if (vendorType !== 'venue' && label[0] === 'Capacity') return
				return (
					<Box key={i} className={styles.infoContent}>
						<div className={styles.businessDetail}>
							<Typography
								variant="h6"
								gutterBottom
								color="#7ca6bd"
								sx={{ fontWeight: 'light' }}
							>
								{label[0]}
							</Typography>
							<Typography gutterBottom variant="h5">
								{label[1]}
							</Typography>
						</div>
					</Box>
				)
			})}
			{editable && (
				<BusinessProfileDetailsModal
					open={editOpen}
					handleClose={() => setEditOpen(false)}
					formData={formData}
					setFormData={setFormData}
				/>
			)}
		</Card>
	)
}
